import { renderSettingsMCQ } from "../MCQ";

const renderSettingsSubjective = renderSettingsMCQ;

export default renderSettingsSubjective;
